import { useState } from 'react';

export const useExpandableRow = (minRowHeight: number, minSubRowHeight: number) => {
    const [rowHeightMap, setRowHeightMap] = useState<Record<string, number>>({});
    const [subItemHeightMap, setSubItemHeightMap] = useState<Record<string, number[]>>({});
    const [openedSubRow, setOpenedSubRow] = useState<Record<string, number[]>>({});

    const subRowRef = (el: HTMLDivElement, index: number, subIndex = 0) => {
        if (!el) {
            return;
        }
        const item = subItemHeightMap[index];
        const subItemHeight = item ? item[subIndex] || minSubRowHeight : minSubRowHeight;
        const elHeight = el.getBoundingClientRect().height || minSubRowHeight;
        if (subItemHeight !== elHeight) {
            setSubItemHeightMap({
                ...subItemHeightMap,
                [index]: {
                    ...subItemHeightMap[index],
                    [subIndex]: elHeight
                }
            });
        }
    };

    const getRowHeight = (index: number) => {
        return rowHeightMap[index] || minRowHeight;
    };

    const setRowHeight = (index: number, size: number) => {
        setRowHeightMap({ ...rowHeightMap, [index]: size });
    };

    const getSubRowFullHeight = (index: number, subIndex = 0) => {
        return subItemHeightMap[index] && subItemHeightMap[index][subIndex];
    };

    const getSubRowHeight = (index: number, subIndex = 0) => {
        return isOpenedSubRow(index, subIndex) ? subItemHeightMap[index][subIndex] || 21 : 21;
    };

    const isOpenedSubRow = (index: number, subIndex = 0) => {
        return openedSubRow[index] && openedSubRow[index].includes(subIndex);
    };

    const isChevronVisible = (index: number, subIndex = 0) => {
        return getSubRowFullHeight(index, subIndex) > minRowHeight;
    };

    const toggleRow = (index: number, subIndex = 0) => {
        !isOpenedSubRow(index, subIndex)
            ? setOpenedSubRow({
                  ...openedSubRow,
                  [index]: [...(openedSubRow[index] || []), subIndex]
              })
            : setOpenedSubRow({
                  ...openedSubRow,
                  [index]: (openedSubRow[index] || []).filter((i: number) => i !== subIndex)
              });
    };

    return {
        rowHeightMap,
        subRowRef,
        getRowHeight,
        setRowHeight,
        getSubRowFullHeight,
        getSubRowHeight,
        toggleRow,
        isOpenedSubRow,
        isChevronVisible
    };
};
